export default function initIntro() {
  const links = document.querySelectorAll('.intro__nav-link');
  const texts = document.querySelectorAll('.intro__text');

  function showLanguage(lang) {
    texts.forEach(text => {
      text.style.display = text.dataset.langContent === lang ? 'block' : 'none';
    });
  }

  links.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const lang = link.dataset.lang;

      links.forEach(l => l.classList.remove('active'));
      link.classList.add('active');

      showLanguage(lang);
    });
  });

  // Show the first language by default
  if (links.length > 0) {
    links[0].classList.add('active');
    showLanguage(links[0].dataset.lang);
  }
}
